module.exports = __webpack_public_path__ + "static/img/service1.bb144791.png";